import React, { Component } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { RawHTML, Button } from "../common";
//import Dotdotdot from "react-dotdotdot";
import styles from "./styles.less";
import PriceDisplay from "../../containers/PriceDisplay";

class RateTableRow extends Component {
  onClick = () => {
    const {
      onClick,
      rateId,
      priceCode,
      planCode,
      allocationCode,
      roomId
    } = this.props;

    onClick({ rateId, priceCode, planCode, allocationCode, roomId });
  };

  onReadeMoreClick = e => {
    e.preventDefault();
    e.stopPropagation(); // so we won't select the rate (parent element)
    const { onReadeMoreClick, rateId, roomId } = this.props;
    onReadeMoreClick({ rateId, roomId });
  };

  renderPriceBox = (
    isClub,
    basePrice,
    currentPrice,
    currentPriceclub,
    isDeal
  ) => {
    const {
      titles,
      clubPercentageDiscount,
      currencyCode,
      currency,
      displayPriceWithoutTaxes
    } = this.props;
    const basePriceIsLower = basePrice > currentPrice && basePrice > 0;
    const clubTitle = `${clubPercentageDiscount}% ${titles.ClubDiscount}`;
    const priceBoxTitle = isClub
      ? clubTitle
      : isDeal
        ? titles.DealPrice
        : basePriceIsLower
          ? titles.WebsiteDoscount
          : titles.OnlineBooking;
    return (
      <div className={styles.priceBoxWrapper}>
        <div
          className={cx(styles.priceBoxTitle, {
            [styles.priceBoxTitleClub]: isClub
          })}
        >
          {priceBoxTitle}
        </div>
        <div className={styles.priceBoxDataWrapper}>
          {basePriceIsLower &&
            !isClub &&
            !displayPriceWithoutTaxes &&
            !displayPriceWithoutTaxes && (
              <span className={styles.basePrice}>
                <PriceDisplay
                  price={basePrice}
                  currentCurrencyCode={currencyCode}
                  fallBackCurrencySymbol={currency}
                >
                  {convertedPrice => convertedPrice}
                </PriceDisplay>
              </span>
            )}
          {isClub && (
            <span className={styles.basePrice}>
              <PriceDisplay
                price={currentPrice}
                currentCurrencyCode={currencyCode}
                fallBackCurrencySymbol={currency}
              >
                {convertedPrice => convertedPrice}
              </PriceDisplay>
            </span>
          )}
          <span className={styles.totalPrice}>
            <PriceDisplay
              price={isClub ? currentPriceclub : currentPrice}
              currentCurrencyCode={currencyCode}
              fallBackCurrencySymbol={currency}
            >
              {convertedPrice => convertedPrice}
            </PriceDisplay>
          </span>
        </div>
      </div>
    );
  };

  renderRate = () => {
    const {
      planName,
      price,
      basePrice,
      simpleClubTotalPrice,
      clubPercentageDiscount,
      titles,
      clubUserLoggedIn,
      isClubActive,
      isDeal
    } = this.props;
    const clubPrice =
      simpleClubTotalPrice || (price * (100 - clubPercentageDiscount)) / 100;
    return (
      <div className={cx(styles.plansData, { [styles.deal]: isDeal })}>
        <div
          className={styles.planName}
          onClick={this.onReadeMoreClick}
          onKeyDown={this.onReadeMoreClick}
          role="button"
          tabIndex="0"
        >
          {planName && <RawHTML html={planName} />}
          <div className={styles.moreDetails}>{titles.ForMoreDetails}</div>
        </div>
        <div className={styles.bookSection}>
          <div className={styles.planPricesBookWrapper}>
            {!clubUserLoggedIn &&
              this.renderPriceBox(false, basePrice, price, null, isDeal)}
            {isClubActive &&
              this.renderPriceBox(true, basePrice, price, clubPrice, isDeal)}
            <div className={styles.rateOrderButtonWrapper}>
              <Button
                title={titles.Checkout}
                onClick={this.onClick}
                isDealStyle={isDeal}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    return <React.Fragment>{this.renderRate()}</React.Fragment>;
  }
}

RateTableRow.propTypes = {
  titles: PropTypes.object,
  rateId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  roomId: PropTypes.string,
  planName: PropTypes.string,
  price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  basePrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  priceCode: PropTypes.string,
  planCode: PropTypes.string,
  simpleClubTotalPrice: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  allocationCode: PropTypes.string,
  onClick: PropTypes.func,
  onReadeMoreClick: PropTypes.func,
  isClubActive: PropTypes.bool,
  clubUserLoggedIn: PropTypes.bool,
  currencyCode: PropTypes.string,
  currency: PropTypes.string,
  isDeal: PropTypes.bool,
  clubPercentageDiscount: PropTypes.number,
  displayPriceWithoutTaxes: PropTypes.bool
};

RateTableRow.defaultProps = {
  showAvailability: true,
  lowAvailabilityCount: 4,
  titles: {
    ReadMore: "Read More..."
  }
};

export default RateTableRow;



// WEBPACK FOOTER //
// ./src/components/RateTableRow/RateTableRow.js